<script setup>
import {computed, defineAsyncComponent, ref} from "vue";
import {useReportOutput} from "@/components/report/outputs/useReportOutput";

const FsLightBox = defineAsyncComponent(() => import('fslightbox-vue'))

const props = defineProps({
  value: [String, Object]
})

const {v, extra} = useReportOutput(props)

// the report's Thumbnail Size, in CSS pixels
const SIZES = {small: 72, medium: 140, large: 240}
const px = computed(() => SIZES[extra.value?.size] || SIZES.small)

/*
 * The full photo, full screen (the gallery's viewer). The viewer is made only
 * once a photo is clicked - not one per row - opening as it mounts; after
 * that the toggler opens it again. (b-img-lazy passes no listeners on: the
 * click is on the wrapper.)
 */
const shown = ref(false)
const toggler = ref(false)
const open = () => {
  if (!extra.value?.url)
    return
  if (shown.value)
    toggler.value = !toggler.value
  else
    shown.value = true
}
</script>

<template>
  <span v-if="extra?.thumb">
    <!-- the viewer beside the thumbnail, not in it: a click in the viewer is not a click on the thumbnail -->
    <span class="report-photo-wrap" @click.stop="open">
      <b-img-lazy :src="extra.thumb" :alt="v" :title="v" :width="px" :height="px" class="report-photo"/>
    </span>
    <fs-light-box v-if="shown" type="image" open-on-mount :toggler="toggler" :sources="[extra.url]"/>
  </span>
</template>

<style scoped>
.report-photo-wrap {
  display: inline-block;
  cursor: zoom-in;
}

.report-photo {
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #ced4da;
}
</style>
